import { methods } from "../../utils/axios";

export default class SelectionProcessAPI {
  static createSelectionProcess(data) {
    return methods.post('/process', data);
  }

  static paginateSelectionProcess(params){
    return methods.post('/process/paginate', params)
  }

  static updateSelectionProcess(data){
    return methods.put('/process', data)
  }

  static deleteSelectionProcess(id){
    return methods.del('/process', id)
  }

}